export const messages = {
  en: {
    resourceStoreManage: {
      addFirstLevel: 'Add First Level',
      addSecondLevel: 'Add Second Level',
      edit: 'Edit',
      delete: 'Delete',
      queryCondition: 'Query Conditions',
      selectStorehouse: 'Select Storehouse',
      enterResourceName: 'Enter Resource Name',
      enterResourceCode: 'Enter Resource Code',
      selectSpec: 'Select Specification',
      selectIsFixed: 'Select Fixed Resource',
      query: 'Query',
      reset: 'Reset',
      resourceInfo: 'Resource Information',
      add: 'Add',
      directPurchase: 'Direct Purchase Inbound',
      directOut: 'Direct Outbound',
      import: 'Import',
      export: 'Export',
      back: 'Back',
      resourceId: 'Resource ID',
      resourceNameCode: 'Resource Name (Code)',
      storeName: 'Storehouse Name',
      resourceType: 'Resource Type',
      resourceSpec: 'Specification',
      referencePrice: 'Reference Price',
      chargeStandard: 'Charge Standard',
      stock: 'Stock',
      minTotal: 'Min Total',
      avgPrice: 'Avg Price',
      totalPrice: 'Total Price',
      operation: 'Operation',
      subTotal: 'Sub Total',
      grandTotal: 'Grand Total',
      yuan: 'Yuan',
      detail: 'Detail',
      confirmOperation: 'Confirm Operation',
      confirmDeleteResource: 'Confirm to delete resource?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete',
      addResource: 'Add Resource',
      resourceName: 'Resource Name',
      resourceCode: 'Resource Code',
      secondCategory: 'Second Category',
      unit: 'Unit',
      fixedResource: 'Fixed Resource',
      warningStock: 'Warning Stock',
      minUnit: 'Min Unit',
      minUnitTip: '[Example] 1 box of nails has 50 pieces, unit is box (1 box), min unit is piece (50 pieces).',
      minUnitQty: 'Min Unit Quantity',
      minCharge: 'Min Charge (Min Unit)',
      maxCharge: 'Max Charge (Min Unit)',
      initialStock: 'Initial Stock',
      remark: 'Remark',
      description: 'Description',
      uploadImage: 'Upload Image',
      selectResourceType: 'Select Resource Type',
      selectSecondCategory: 'Select Second Category',
      selectUnit: 'Select Unit',
      enterReferencePrice: 'Enter Reference Price',
      enterWarningStock: 'Enter Warning Stock',
      selectMinUnit: 'Select Min Unit',
      enterMinUnitQty: 'Enter Min Unit Quantity',
      enterMinCharge: 'Enter Min Charge',
      enterMaxCharge: 'Enter Max Charge',
      enterInitialStock: 'Enter Initial Stock',
      enterRemark: 'Enter Remark',
      enterDescription: 'Enter Description',
      addSuccess: 'Add Success',
      resourceNameRequired: 'Resource name is required',
      resourceNameLength: 'Resource name length 2-100 characters',
      resourceCodeRequired: 'Resource code is required',
      resourceCodeMaxLength: 'Resource code max length 50 characters',
      resourceTypeRequired: 'Resource type is required',
      secondCategoryRequired: 'Second category is required',
      unitRequired: 'Unit is required',
      isFixedRequired: 'Fixed resource is required',
      storehouseRequired: 'Storehouse is required',
      referencePriceRequired: 'Reference price is required',
      priceFormatError: 'Price format error',
      warningStockRequired: 'Warning stock is required',
      warningStockMin: 'Warning stock min is 0',
      minUnitRequired: 'Min unit is required',
      minUnitQtyRequired: 'Min unit quantity is required',
      minChargeRequired: 'Min charge is required',
      maxChargeRequired: 'Max charge is required',
      chargeFormatError: 'Charge format error',
      initialStockRequired: 'Initial stock is required',
      maxChargeError: 'Max charge cannot be less than min charge',
      editResource: 'Edit Resource',
      updateSuccess: 'Update Success',
      confirmDeleteResourceType: 'Confirm to delete resource type?',
      importResource: 'Import Resource',
      browse: 'Browse',
      selectDataFile: 'Select data file',
      downloadTemplate: 'Download Template',
      downloadTemplateTip1: 'Please download',
      resourceTemplate: 'Resource Template',
      downloadTemplateTip2: 'prepare data, then upload to import',
      importSuccess: 'Import Success',
      fileRequired: 'File is required',
      invalidExcelFormat: 'Invalid Excel format',
      fileSizeLimit: 'File size cannot exceed 2MB',
      addFirstLevelType: 'Add First Level Type',
      addSecondLevelType: 'Add Second Level Type',
      typeName: 'Type Name',
      enterTypeName: 'Enter type name',
      enterTypeDescription: 'Enter type description',
      typeNameRequired: 'Type name is required',
      addTypeSuccess: 'Add type success',
      editResourceType: 'Edit Resource Type',
      updateTypeSuccess: 'Update type success',
      deleteTypeSuccess: 'Delete type success',
      inboundTime: 'Inbound Time',
      unitPrice: 'Unit Price',
      fetchTotalPriceError: 'Failed to get total price details',
      storehouse: 'Storehouse',
      selectType: 'Please select resource type'
    },
    resourceStoreTimes:{
      title: 'Total Price Details',
      itemCode: 'Item Code',
      inboundTime: 'Inbound Time',
      unitPrice: 'Unit Price',
      stock: 'Stock',
      totalPrice: 'Total Price',
    }
  },
  zh: {
    resourceStoreManage: {
      addFirstLevel: '添加一级',
      addSecondLevel: '添加二级',
      edit: '修改',
      delete: '删除',
      queryCondition: '查询条件',
      selectStorehouse: '请选择仓库',
      enterResourceName: '请输入物品名称',
      enterResourceCode: '请输入物品编码',
      selectSpec: '请选择物品规格',
      selectIsFixed: '请选择物品是否固定',
      query: '查询',
      reset: '重置',
      resourceInfo: '物品信息',
      add: '添加',
      directPurchase: '直接采购入库',
      directOut: '直接出库',
      import: '导入',
      export: '导出',
      back: '返回',
      resourceId: '物品ID',
      resourceNameCode: '物品名称(编号)',
      storeName: '仓库名称',
      resourceType: '物品类型',
      resourceSpec: '物品规格',
      fixedResource: '固定物品',
      referencePrice: '参考价格',
      chargeStandard: '收费标准',
      stock: '物品库存',
      minUnit: '最小计量',
      minTotal: '最小计量总数',
      avgPrice: '物品均价',
      totalPrice: '物品总价',
      operation: '操作',
      subTotal: '小计',
      grandTotal: '大计',
      yuan: '元',
      detail: '详情',
      confirmOperation: '请确认您的操作',
      confirmDeleteResource: '确定删除物品管理?',
      cancelDelete: '点错了',
      confirmDelete: '确认删除',
      addResource: '添加物品',
      resourceName: '物品名称',
      resourceCode: '物品编码',
      secondCategory: '二级分类',
      unit: '物品单位',
      warningStock: '警告库存',
      minUnitTip: '【例】1盒钉子50个，物品单位为盒（1盒），最小计量单位为个（50个）',
      minUnitQty: '最小计量数量',
      minCharge: '最低收费标准(最小计量单位)',
      maxCharge: '最高收费标准(最小计量单位)',
      initialStock: '初始库存',
      remark: '备注',
      description: '描述',
      uploadImage: '上传图片',
      selectResourceType: '请选择物品类型',
      selectSecondCategory: '请选择二级分类',
      selectUnit: '请选择物品单位',
      enterReferencePrice: '请输入物品采购参考价格',
      enterWarningStock: '请输入警告库存',
      selectMinUnit: '请选择物品最小计量单位',
      enterMinUnitQty: '请输入最小计量单位数量',
      enterMinCharge: '请输入物品最小计量单位，最低收费标准',
      enterMaxCharge: '请输入物品最小计量单位，最高收费标准',
      enterInitialStock: '请输入出入库存',
      enterRemark: '请填写备注',
      enterDescription: '请填写描述',
      addSuccess: '添加成功',
      resourceNameRequired: '物品名称不能为空',
      resourceNameLength: '物品名称长度为2至100',
      resourceCodeRequired: '物品编码不能为空',
      resourceCodeMaxLength: '物品编码不能超过50位',
      resourceTypeRequired: '物品类型不能为空',
      secondCategoryRequired: '二级分类不能为空',
      unitRequired: '单位不能为空',
      isFixedRequired: '是否是固定物品不能为空',
      storehouseRequired: '仓库不能为空',
      referencePriceRequired: '物品价格不能为空',
      priceFormatError: '物品价格格式错误',
      warningStockRequired: '警告库存不能为空',
      warningStockMin: '警告库存最小为零',
      minUnitRequired: '最小计量单位不能为空',
      minUnitQtyRequired: '最小计量单位数量不能为空',
      minChargeRequired: '最低收费标准不能为空',
      maxChargeRequired: '最高收费标准不能为空',
      chargeFormatError: '收费标准格式错误',
      initialStockRequired: '出入库存不能为空',
      maxChargeError: '最高收费标准不能小于最低收费标准',
      editResource: '修改物品',
      updateSuccess: '修改成功',
      confirmDeleteResourceType: '确定删除物品类型?',
      importResource: '物品导入',
      browse: '浏览',
      selectDataFile: '请选择数据文件',
      downloadTemplate: '下载模板',
      downloadTemplateTip1: '请先下载',
      resourceTemplate: '物品模板',
      downloadTemplateTip2: '准备数据后，上传导入',
      importSuccess: '导入成功',
      fileRequired: '文件不能为空',
      invalidExcelFormat: '不是有效的Excel格式',
      fileSizeLimit: 'Excel文件大小不能超过2M',
      addFirstLevelType: '添加一级类型',
      addSecondLevelType: '添加二级类型',
      typeName: '类型名称',
      enterTypeName: '请填写物品类型名称',
      enterTypeDescription: '请填写物品类型描述',
      typeNameRequired: '类型名称不能为空',
      addTypeSuccess: '添加类型成功',
      editResourceType: '修改物品类型',
      updateTypeSuccess: '修改类型成功',
      deleteTypeSuccess: '删除类型成功',
      inboundTime: '入库时间',
      unitPrice: '单价',
      fetchTotalPriceError: '获取物品总价详情失败',
      storehouse: '仓库',
      selectType: '请选择物品类型'
    },
resourceStoreTimes:{
      title: '物品总价详情',
      itemCode: '物品编码',
      inboundTime: '入库时间',
      unitPrice: '单价',
      stock: '库存',
      totalPrice: '总价',
    }
  },
  'zh-TW': {
    resourceStoreManage: {
      addFirstLevel: '添加一級',
      addSecondLevel: '添加二級',
      edit: '修改',
      delete: '刪除',
      queryCondition: '查詢條件',
      selectStorehouse: '請選擇倉庫',
      enterResourceName: '請輸入物品名稱',
      enterResourceCode: '請輸入物品編碼',
      selectSpec: '請選擇物品規格',
      selectIsFixed: '請選擇物品是否固定',
      query: '查詢',
      reset: '重置',
      resourceInfo: '物品信息',
      add: '添加',
      directPurchase: '直接採購入庫',
      directOut: '直接出庫',
      import: '導入',
      export: '導出',
      back: '返回',
      resourceId: '物品ID',
      resourceNameCode: '物品名稱(編號)',
      storeName: '倉庫名稱',
      resourceType: '物品類型',
      resourceSpec: '物品規格',
      fixedResource: '固定物品',
      referencePrice: '參考價格',
      chargeStandard: '收費標準',
      stock: '物品庫存',
      minUnit: '最小計量',
      minTotal: '最小計量總數',
      avgPrice: '物品均價',
      totalPrice: '物品總價',
      operation: '操作',
      subTotal: '小計',
      grandTotal: '大計',
      yuan: '元',
      detail: '詳情',
      confirmOperation: '請確認您的操作',
      confirmDeleteResource: '確定刪除物品管理?',
      cancelDelete: '點錯了',
      confirmDelete: '確認刪除',
      addResource: '添加物品',
      resourceName: '物品名稱',
      resourceCode: '物品編碼',
      secondCategory: '二級分類',
      unit: '物品單位',
      warningStock: '警告庫存',
      minUnitTip: '【例】1盒釘子50個，物品單位為盒（1盒），最小計量單位為個（50個）',
      minUnitQty: '最小計量數量',
      minCharge: '最低收費標準(最小計量單位)',
      maxCharge: '最高收費標準(最小計量單位)',
      initialStock: '初始庫存',
      remark: '備註',
      description: '描述',
      uploadImage: '上傳圖片',
      selectResourceType: '請選擇物品類型',
      selectSecondCategory: '請選擇二級分類',
      selectUnit: '請選擇物品單位',
      enterReferencePrice: '請輸入物品採購參考價格',
      enterWarningStock: '請輸入警告庫存',
      selectMinUnit: '請選擇物品最小計量單位',
      enterMinUnitQty: '請輸入最小計量單位數量',
      enterMinCharge: '請輸入物品最小計量單位，最低收費標準',
      enterMaxCharge: '請輸入物品最小計量單位，最高收費標準',
      enterInitialStock: '請輸入出入庫存',
      enterRemark: '請填寫備註',
      enterDescription: '請填寫描述',
      addSuccess: '添加成功',
      resourceNameRequired: '物品名稱不能為空',
      resourceNameLength: '物品名稱長度為2至100',
      resourceCodeRequired: '物品編碼不能為空',
      resourceCodeMaxLength: '物品編碼不能超過50位',
      resourceTypeRequired: '物品類型不能為空',
      secondCategoryRequired: '二級分類不能為空',
      unitRequired: '單位不能為空',
      isFixedRequired: '是否是固定物品不能為空',
      storehouseRequired: '倉庫不能為空',
      referencePriceRequired: '物品價格不能為空',
      priceFormatError: '物品價格格式錯誤',
      warningStockRequired: '警告庫存不能為空',
      warningStockMin: '警告庫存最小為零',
      minUnitRequired: '最小計量單位不能為空',
      minUnitQtyRequired: '最小計量單位數量不能為空',
      minChargeRequired: '最低收費標準不能為空',
      maxChargeRequired: '最高收費標準不能為空',
      chargeFormatError: '收費標準格式錯誤',
      initialStockRequired: '出入庫存不能為空',
      maxChargeError: '最高收費標準不能小於最低收費標準',
      editResource: '修改物品',
      updateSuccess: '修改成功',
      confirmDeleteResourceType: '確定刪除物品類型?',
      importResource: '物品導入',
      browse: '瀏覽',
      selectDataFile: '請選擇數據文件',
      downloadTemplate: '下載模板',
      downloadTemplateTip1: '請先下載',
      resourceTemplate: '物品模板',
      downloadTemplateTip2: '準備數據後，上傳導入',
      importSuccess: '導入成功',
      fileRequired: '文件不能為空',
      invalidExcelFormat: '不是有效的Excel格式',
      fileSizeLimit: 'Excel文件大小不能超過2M',
      addFirstLevelType: '添加一級類型',
      addSecondLevelType: '添加二級類型',
      typeName: '類型名稱',
      enterTypeName: '請填寫物品類型名稱',
      enterTypeDescription: '請填寫物品類型描述',
      typeNameRequired: '類型名稱不能為空',
      addTypeSuccess: '添加類型成功',
      editResourceType: '修改物品類型',
      updateTypeSuccess: '修改類型成功',
      deleteTypeSuccess: '刪除類型成功',
      inboundTime: '入庫時間',
      unitPrice: '單價',
      fetchTotalPriceError: '獲取物品總價詳情失敗',
      storehouse: '倉庫',
      selectType: '請選擇物品類型'
    },
    resourceStoreTimes:{
      title: '物品總價詳情',
      itemCode: '物品編碼',
      inboundTime: '入庫時間',
      unitPrice: '單價',
      stock: '庫存',
      totalPrice: '總價',
    }
  }
}